// extracted by mini-css-extract-plugin
export default {"nextLevel":"nextLevel--BKBS0","slideIn":"slideIn--u6QTH","body":"body--faIbL","slideOut":"slideOut--mGu6l"};